import { downloadWorkReportAttachment } from '../../../api/workReport';
import {
  WorkReport,
  workReportStatusClass,
  workReportStatusLabel,
} from '../../../types/workReport';
import { formatDate, formatSize } from './previewShared';
import '../../mypage/LeaveRequestPanel.css';

interface Props {
  detail: WorkReport;
}

function WorkReportPreviewView({ detail }: Props) {
  return (
    <article className="leave-panel__detail">
      <div className="leave-panel__detail-head">
        <div>
          <span
            className={`leave-panel__status is-${workReportStatusClass(
              detail.status,
              detail.approvalInProgress
            )}`}
          >
            {workReportStatusLabel(detail.status, detail.approvalInProgress)}
          </span>
          <h3>{detail.title}</h3>
          <p>
            {detail.authorName || '-'} · 보고일 {formatDate(detail.reportDate)}
            {detail.approverName ? ` · 승인자 ${detail.approverName}` : ''}
          </p>
        </div>
      </div>
      <div className="leave-panel__content">{detail.content}</div>

      {detail.attachments && detail.attachments.length > 0 ? (
        <div className="bulletin-panel__detail-files" style={{ marginTop: 18 }}>
          <strong>첨부파일</strong>
          <ul>
            {detail.attachments.map((file) => (
              <li key={file.attachmentId}>
                <button
                  type="button"
                  onClick={() =>
                    void downloadWorkReportAttachment(
                      detail.workReportId,
                      file.attachmentId,
                      file.fileName
                    )
                  }
                >
                  {file.fileName}
                  {file.fileSize != null ? ` (${formatSize(file.fileSize)})` : ''}
                </button>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </article>
  );
}

export default WorkReportPreviewView;
